webpackJsonp([123714094920601],{

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/background.e16428c8.jpg";

/***/ }),

/***/ 254:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(27);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _background = __webpack_require__(97);
	
	var _background2 = _interopRequireDefault(_background);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ObslugaPage = function (_React$Component) {
	  _inherits(ObslugaPage, _React$Component);
	
	  function ObslugaPage() {
	    _classCallCheck(this, ObslugaPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  ObslugaPage.prototype.render = function render() {
	    var data = this.props.data;
	    var obsluga = data.allMarkdownRemark.edges;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'section',
	        {
	          className: 'hero is-info is-small ', style: {
	            backgroundImage: "url(" + _background2.default + ")"
	
	          } },
	        _react2.default.createElement(
	          'div',
	          { className: 'hero-body' },
	          _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'columns' },
	              _react2.default.createElement(
	                'div',
	                { className: 'column' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'mytitle' },
	                  'Obs\u0142uga'
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          obsluga.filter(function (obsluga) {
	            return obsluga.node.frontmatter.templateKey === 'obsluga-post';
	          }).map(function (_ref) {
	            var obsluga = _ref.node;
	            return _react2.default.createElement(
	              'div',
	              {
	                className: 'content',
	                style: { border: '1px solid #b8d8e7', padding: '2em 4em' },
	                key: obsluga.id
	              },
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'has-text-primary', to: obsluga.fields.slug },
	                  obsluga.frontmatter.title
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                obsluga.excerpt,
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { className: 'button is-small', to: obsluga.fields.slug },
	                  'Czytaj Wi\u0119cej'
	                )
	              )
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return ObslugaPage;
	}(_react2.default.Component);
	
	exports.default = ObslugaPage;
	
	
	ObslugaPage.propTypes = {
	  data: _propTypes2.default.shape({
	    allMarkdownRemark: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    })
	  })
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-obsluga-js-9a95a842398c061cabbc.js